// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".specs .divider{display:none}.specs .specs-values{padding:var(--space-3) 0px}.specs .specs-values .specs-row:not(:first-child){padding-top:var(--space-3)}.specs .specs-values .specs-row:not(:last-child){padding-bottom:var(--space-3);border-bottom:1px solid var(--grey-light)}.specs .specs-values .specs-row .specs-title{text-transform:uppercase;font-family:var(--font-bold);font-size:var(--font-size-14);padding-right:var(--space-2);line-height:1.25rem}.specs .specs-values .specs-row .specs-value{font-size:var(--font-size-14)}@media (max-width: 969px){.specs .divider{display:block;margin-top:10px;margin-bottom:24px}}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
